import { Route, RouteProps } from "react-router-dom";

import { setDocumentTitle } from "helpers/routing";

interface IProps extends RouteProps {
  documentTitle: string;
}

class PageRoute extends Route<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    setDocumentTitle(this.props.documentTitle);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidUpdate() {
    setDocumentTitle(this.props.documentTitle);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { documentTitle, ...rest } = this.props;

    return <Route {...rest} />;
  }
}

export default PageRoute;
